export function createNestedObject(base, keys, value) {
  keys.reduce((acc, key, index) => {
    if (index === keys.length - 1) {
      acc[key] = value;
      return;
    }
    acc[key] = acc[key] || {};
    return acc[key];
  }, base);
}

export function transformObject(input: any) {
  const output = {};

  for (const [key, value] of Object.entries(input ?? {})) {
    const keys = key.split('#').filter(key => key);
    createNestedObject(output, keys, value);
  }

  return output;
}
